import React, { useState, useEffect } from "react";
import Dashboard from "../../layouts/Dashboard";
import Axios from "axios";
import url from "../../services/url";
import LoadingArea from "../../components/LoadingArea";
import { Link, useParams } from "react-router-dom";
import ContactCreator from "./FormContacts/ContactCreator";

import axios from "../../services/axios";

import Papa from "papaparse";
import swal from "sweetalert";
import exportFromJSON from "export-from-json";
import { usePapaParse } from "react-papaparse";

import $ from "jquery";
import ReactLoading from "react-loading";
import isConsultant from "../../services/isConsultant";

//import DataTable from "../../components/DataTable";

const AGENT_APPLICATION_ID = "61d41ac7cc03506243d626f9";

//datatable
var dt = require("datatables.net");
require("datatables.net-bs4");
$.DataTable = dt;

function FormContacts() {
  // States
  const [load, setLoad] = useState(true);
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const [bulkUpload, setBulkUpload] = useState("");
  const [datas, setDatas] = useState(null);
  const [disableButton, setDisableButton] = useState(false);
  const [formName, setFormName] = useState("");

  useEffect(() => {
    {
      id &&
        axios
          .get(`/formtemplate`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          })
          .then((res) => {
            const data = res.data;
            data.map((ele) => {
              if (ele._id === id) {
                setFormName(ele.name.split(" ").join("-"));
              }
            });
          });
    }
  }, [id]);

  // // Effects
  // useEffect(() => {
  //   loadContacts();
  // }, []);

  // useEffect(() => {
  //   // $("#table-datatable").DataTable({
  //   //   columnDefs: [{ type: "date", targets: [5] }],
  //   //   order: [[5, "desc"]], //or asc
  //   // });
  //   setTimeout(() => {
  //     $("#table-datatable").DataTable({
  //       order: [[6, "desc"]],
  //       columnDefs: [{ targets: 6, type: "date-eu" }],
  //       bDestroy: true,
  //       responsive: true,
  //     });
  //   }, 100);
  // });

  // candidate load
  // function loadContacts() {
  //   axios
  //     .get("contacts/" + id, {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("user.token")}`,
  //       },
  //     })
  //     .then((res) => {
  //       setContacts(res.data);
  //       console.log("res dattttaaaa", res.data);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }

  // function onClickDeleteContact(e) {
  //   const contactId = e.target.getAttribute("contact");
  //   axios
  //     .delete("contacts/" + contactId, {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("user.token")}`,
  //       },
  //     })
  //     .then((res) => {
  //       setLoading(true);
  //       loadContacts();
  //     })
  //     .catch(console.error);
  // }

  // function onClickSendReminder(e) {
  //   const button = e.target;
  //   button.disabled = true;
  //   const contactId = e.target.getAttribute("contact");
  //   axios
  //     .post("contacts/" + contactId + "/remind", {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("user.token")}`,
  //       },
  //     })
  //     .then((res) => {
  //       button.disabled = false;
  //     })
  //     .catch(console.error);
  // }

  // add function for download csv data
  // function onClickDownloadCSV() {
  //   let rows = [
  //     [
  //       "Id",
  //       "space",
  //       "Name",
  //       "Email",
  //       "Phone Number",
  //       "Source",
  //       "Candidate",
  //       "Date Sent",
  //       "std Date Sent",
  //       "Updated At",
  //     ],
  //     ...contacts.map((contact) => Object.values(contact)),
  //   ];
  //   let csv =
  //     "data:text/csv;charset=utf-8," +
  //     rows
  //       .map((e) =>
  //         e
  //           .filter((_) => typeof _ === "string" || _ instanceof String)
  //           .join(",")
  //       )

  //       .join("\n");

  //   var encodedUri = encodeURI(csv);
  //   var link = document.createElement("a");
  //   link.setAttribute("href", encodedUri);
  //   link.setAttribute("download", "candidates.csv");
  //   document.body.appendChild(link); // Required for FF
  //   link.click();
  // }

  let agentSampleData = [
    {
      "Name": "John Doe",
      "Email": "john.doe@example.com",
      "Phone Number": "9876543210",
      "Date of Birth": "01/09/1995",
      "Highest Qualification": "Graduate",
      "How did you come to know about us": "Social Media",
      "What type of job are you looking for?": "Permanent/Full-time",
      "How would you rate your English communication skills on a scale of 1 to 5 with 5 being excellent?": "5-Excellent",
      "Preferred Location": "Amritsar",
      "What is your preferred mode of interview?": "In-person",
      "Does your household fall under any of the following categories?": "None of the above",
      "Select Department": "Operations",
      "Select Designation": "CSE"
    },
    {
      "Name": "Rahul Sharma",
      "Email": "rahul.sharma@example.com",
      "Phone Number": "9876543211",
      "Date of Birth": "15/05/1997",
      "Highest Qualification": "12th",
      "How did you come to know about us": "Direct Visit",
      "What type of job are you looking for?": "Permanent/Full-time",
      "How would you rate your English communication skills on a scale of 1 to 5 with 5 being excellent?": "4-Good",
      "Preferred Location": "Vadodara",
      "What is your preferred mode of interview?": "Virtual (Video call)",
      "Does your household fall under any of the following categories?": "Below Poverty Line (BPL) household",
      "Select Department": "Operations",
      "Select Designation": "CSE"
    }
  ];

  let defaultSampleData = [
    {
      name: "test",
      email: "test@gmail.com",
      phone: "1010101010",
      source: "consultant",
      location: "amritsar",
      current_location: "amritsar",
      date: "DD/MM/YYYY",
    },
    {
      name: "test",
      email: "test@gmail.com",
      phone: "1010101010",
      source: "self sourcing",
      location: "ludhiana",
      current_location: "ludhiana",
      date: "DD/MM/YYYY",
    },
    {
      name: "test",
      email: "test@gmail.com",
      phone: "1010101010",
      source: "digital marketing",
      location: "kolkata",
      current_location: "kolkata",
      date: "DD/MM/YYYY",
    },
    {
      name: "test",
      email: "test@gmail.com",
      phone: "1010101010",
      source: "Walk In",
      location: "amritsar",
      current_location: "amritsar",
      date: "DD/MM/YYYY",
    },
  ];

  const currentFormName = (formName || "").toLowerCase().replace(/[^a-z]/g, "");
  const isAgentForm = id === AGENT_APPLICATION_ID || currentFormName.includes("agent");

  const handleClickSample = () => {
    const exportData = isAgentForm ? agentSampleData : defaultSampleData;
    exportFromJSON({
      data: exportData,
      exportType: "csv",
      fileName: isAgentForm ? "Agent_Application_Sample" : "candidates"
    });
  };

  //download csv data after submit
  const [CsvFinalSubmitData, setCsvFinalSubmitData] = useState();

  const nullData = [];
  const correctData = [];
  const [submitCorrectData, setSubmitCorrectData] = useState();
  const [submitNullData, setSubmitNullData] = useState();

  console.log("submit null data", submitNullData);

  const downloadFinalData = () => {
    if (submitNullData && submitNullData.length > 0) {
      const formattedData = submitNullData.map((element) => {
        const { status, Reason, reason, Status, rawRow, isMissingMandatory, missingReason, ...rest } = element;
        return {
          ...rest,
          Status: Status || status || "Failed",
          Reason: Reason || reason || Status || status || "Validation error",
        };
      });
      const exportType = "csv";
      const fileName = isAgentForm ? "Agent_Application_Error_Report" : "Bulk_Upload_Error_Report";
      exportFromJSON({ data: formattedData, exportType, fileName });
    }
    window.location.reload();
  };

  //handle BUlk upload
  const handleBulkUpload = (e) => {
    setBulkUpload(e.target.value);
    // if(bulkUpload==="Excel"){
    //   setsubmitcsvdata('')
    //   setcsvdata('')
    // }else{
    //   setExcelData(null)
    // }
  };

  //csv submit
  const [csvdata, setcsvdata] = useState("");
  const [submitcsvdata, setsubmitcsvdata] = useState("");
  const [csvfileError, setcsvfileError] = useState("");

  const [file, setFile] = useState();
  const [fileName, setFileName] = useState("");

  const handlecsvdata = (e) => {
    setFile(e.target.files[0]);
    setFileName(e.target.files[0].name);
    const files = e.target.files;
    let selectedFile = e.target.files[0];
    let size = selectedFile.size / 1000000;

    // console.log("csv size",size)
    if (size < 5) {
      if (files) {
        Papa.parse(files[0], {
          header: true,
          complete: function (results) {
            setcsvfileError("");
            setcsvdata(results.data);

            const finaldata = results.data;
            console.log("final dataaa", finaldata);
            if (finaldata.length <= 2001) {
              if (finaldata.length !== 1) {
                for (let i = 0; i < 1; i++) {
                  let finalDataHeader = Object.keys(finaldata[i]);
                  console.log("Uploaded CSV Headers:", finalDataHeader);

                  let headersVerify = [
                    "name",
                    "email",
                    "phone",
                    "source",
                    "location",
                    "current_location",
                    "date",
                  ];

                  const getVal = (item, keys) => {
                    if (!item) return "";
                    for (const k of keys) {
                      if (item[k] !== undefined && item[k] !== null && String(item[k]).trim() !== "") {
                        return String(item[k]).trim();
                      }
                    }
                    return "";
                  };

                  const normalizePhone = (val) => {
                    if (!val) return "";
                    let str = String(val).trim();
                    if (str.includes("e") || str.includes("E") || str.includes("+")) {
                      const num = Number(str);
                      if (!isNaN(num)) {
                        str = Math.round(num).toString();
                      }
                    }
                    return str.replace(/\D/g, "");
                  };

                  // Filter out empty rows (e.g. trailing blank lines in CSV)
                  const validData = finaldata.filter((e) => {
                    const n = getVal(e, ["Name", "name"]);
                    const p = normalizePhone(getVal(e, ["Phone Number", "phone", "Phone"]));
                    const em = getVal(e, ["Email", "email"]);
                    return (n && n.trim() !== "") || (p && p.trim() !== "") || (em && em.trim() !== "");
                  });

                  // for headers verification
                  let checker = (arr, target) =>
                    target.every((v) => arr.includes(v));

                  const agentMandatoryHeaders = [
                    { label: "Name", aliases: ["name", "full name"] },
                    { label: "Email", aliases: ["email"] },
                    { label: "Phone Number", aliases: ["phone number", "phone", "mobile no", "mobile"] },
                    { label: "Date of Birth", aliases: ["date of birth", "date_of_birth", "dob"] },
                    { label: "Highest Qualification", aliases: ["highest qualification", "qualification"] },
                    { label: "How did you come to know about us", aliases: ["how did you come to know about us", "source"] },
                    { label: "What type of job are you looking for?", aliases: ["what type of job are you looking for?", "what type of job are you looking for", "job_type", "job type"] },
                    { label: "How would you rate your English communication skills on a scale of 1 to 5 with 5 being excellent?", aliases: ["how would you rate your english communication skills on a scale of 1 to 5 with 5 being excellent?", "how would you rate your english communication skills on a scale of 1 to 5 with 5 being excellent", "english_skills", "english skills"] },
                    { label: "Preferred Location", aliases: ["preferred location", "location"] },
                    { label: "What is your preferred mode of interview?", aliases: ["what is your preferred mode of interview?", "what is your preferred mode of interview", "interview_mode", "mode of interview"] },
                    { label: "Does your household fall under any of the following categories?", aliases: ["does your household fall under any of the following categories?", "does your household fall under any of the following categories? ", "household category", "household_category", "household categories"] },
                    { label: "Select Department", aliases: ["select department", "department"] },
                    { label: "Select Designation", aliases: ["select designation", "designation"] },
                  ];

                  const missingHeaders = isAgentForm
                    ? agentMandatoryHeaders
                        .filter(
                          (req) =>
                            !finalDataHeader.some((h) =>
                              req.aliases.includes(h.trim().toLowerCase())
                            )
                        )
                        .map((req) => req.label)
                    : [];

                  const validateHeader = isAgentForm
                    ? missingHeaders.length === 0
                    : checker(finalDataHeader, headersVerify);

                  if (!validateHeader) {
                    setcsvfileError(
                      isAgentForm
                        ? `Missing mandatory header(s): ${missingHeaders.join(", ")}`
                        : "Headers are mismatched"
                    );
                  } else {
                    const dateFormat = /^(\d{2})[\/\-](\d{2})[\/\-](\d{4})|^(\d{4})[\/\-](\d{2})[\/\-](\d{2})/;
                    var format = /[!@#$%^&*()_+\-=\[\]{0-9};':"\\|,.<>\/?]+/;
                    let isnum = /^\d+$/;
                    const emailPattern =
                      "(^s*$|^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.(?:[a-zA-Z]{2}|com|org|net|edu|gov|mil|biz|info|mobi|name|aero|asia|jobs|museum)$)";

                    const AGENT_FORM_OPTIONS = {
                      qualification: ["10th", "12th", "Graduate", "Post-graduate"],
                      source: [
                        "Social Media",
                        "Consultant",
                        "Inbound",
                        "Employee reference",
                        "Campus",
                        "Job Portal",
                        "Maxicus website",
                        "Direct Visit",
                        "Others",
                        "Phygital",
                        "Facebook ads",
                        "Instagram ads",
                        "Ex-Consultant",
                        "Walk In",
                        "Sarbbbb",
                      ],
                      jobType: ["Permanent/Full-time", "Part-time", "Gig/Freelance"],
                      englishSkills: ["5-Excellent", "4-Good", "3-Average", "2-Fair", "1-Poor"],
                      preferredLocation: ["Amritsar", "Vadodara", "Kolkata", "Bangalore", "Gurugram", "Pune"],
                      interviewMode: ["In-person", "Virtual (Video call)", "Telephonic"],
                      householdCategory: [
                        "Below Poverty Line (BPL) household",
                        "MGNREGA worker household (at least 15 days of work by any family member in the previous financial year)",
                        "Household holding an RSBY (Rashtriya Swasthya Bima Yojana) card, with the candidate's details mentioned on it",
                        "Household issued an Antyodaya Anna Yojana (AAY) card",
                        "Household issued a BPL PDS (Public Distribution System) card",
                        "A family member is a member of a Self Help Group (SHG) under NRLM",
                        "Household covered under SECC 2011 auto-inclusion parameters",
                        "None of the above",
                      ],
                    };

                    const matchDropdownOption = (val, options) => {
                      if (!val) return null;
                      const clean = String(val).trim().toLowerCase().replace(/[\s\-_/]/g, "");
                      return options.find(
                        (opt) =>
                          opt.toLowerCase().replace(/[\s\-_/]/g, "") === clean
                      ) || null;
                    };

                    const sourceFormat = [
                      "consultant",
                      "erp",
                      "walkin",
                      "digitalmarketing",
                      "naukri",
                      "socialmedia",
                      "directvisit",
                      "campus",
                    ];
                    const alphabets = /^[-a-zA-Z][-a-zA-Z ]*$/;

                    // for finding data with duplicate numbers
                    const lookup = validData.reduce((a, e) => {
                      const p = normalizePhone(getVal(e, ["Phone Number", "phone", "Phone"]));
                      if (p) a[p] = (a[p] || 0) + 1;
                      return a;
                    }, {});

                    const data = validData.filter((e) => {
                      const p = normalizePhone(getVal(e, ["Phone Number", "phone", "Phone"]));
                      return p && lookup[p] > 1;
                    });

                    // for finding data with duplicate email
                    const removeEmptyString = validData.filter((ele) => {
                      const em = getVal(ele, ["Email", "email"]);
                      return em !== "";
                    });

                    const duplicateIds = removeEmptyString
                      .map((v) => getVal(v, ["Email", "email"]))
                      .filter((v, i, vIds) => vIds.indexOf(v) !== i);
                    const duplicateEmail = validData.filter((obj) =>
                      duplicateIds.includes(getVal(obj, ["Email", "email"]))
                    );

                    if (data.length > 0 || duplicateEmail.length > 0) {
                      for (const element of data) {
                        nullData.push({
                          ...element,
                          Status: "Failed",
                          Reason: "Duplicate Phone Number in file",
                        });
                      }
                      for (const element of duplicateEmail) {
                        nullData.push({
                          ...element,
                          Status: "Failed",
                          Reason: "Duplicate Email in file",
                        });
                      }
                    }

                    function isFutureDate(idate) {
                      if (!idate) return false;
                      var today = new Date().getTime();
                      var str = String(idate).trim();
                      var parts = str.includes("-") ? str.split("-") : str.includes("/") ? str.split("/") : [];
                      if (parts.length < 3) return false;

                      var year, month, day;
                      if (parts[0].length === 4) {
                        year = parseInt(parts[0], 10);
                        month = parseInt(parts[1], 10) - 1;
                        day = parseInt(parts[2], 10);
                      } else {
                        year = parseInt(parts[2], 10);
                        month = parseInt(parts[1], 10) - 1;
                        day = parseInt(parts[0], 10);
                      }
                      var dObj = new Date(year, month, day).getTime();
                      return today - dObj < 0 ? true : false;
                    }

                    for (let i = 0; i < validData.length; i++) {
                      const item = validData[i];
                      var str5 = getVal(item, ["date", "Date", "Date Credit"]);
                      var str4 = normalizePhone(getVal(item, ["Phone Number", "phone", "Phone"]));
                      var str3 = getVal(item, ["Preferred Location", "location", "Location"]);
                      var str2 = getVal(item, ["How did you come to know about us", "source", "Source"]);
                      var str1 = getVal(item, ["Name", "name"]);
                      var strEmail = getVal(item, ["Email", "email"]);
                      var strCurrentLocation = getVal(item, ["Current Location", "current_location"]);

                      let isAgentValidationError = false;
                      let agentValidationReason = "";

                      if (isAgentForm) {
                        const dob = getVal(item, ["Date of Birth", "date_of_birth", "DOB"]);
                        const qual = getVal(item, ["Highest Qualification", "qualification"]);
                        const jobType = getVal(item, ["What type of job are you looking for?", "job_type"]);
                        const engSkills = getVal(item, ["How would you rate your English communication skills on a scale of 1 to 5 with 5 being excellent?", "english_skills"]);
                        const prefMode = getVal(item, ["What is your preferred mode of interview?", "interview_mode"]);
                        const household = getVal(item, [
                          "Does your household fall under any of the following categories?",
                          "Does your household fall under any of the following categories? ",
                          "household category",
                          "household_category"
                        ]);
                        const selectDept = getVal(item, ["Select Department", "department"]);
                        const selectDesg = getVal(item, ["Select Designation", "designation"]);

                        const matchedQual = matchDropdownOption(qual, AGENT_FORM_OPTIONS.qualification);
                        const matchedSource = matchDropdownOption(str2, AGENT_FORM_OPTIONS.source);
                        const matchedJobType = matchDropdownOption(jobType, AGENT_FORM_OPTIONS.jobType);
                        const matchedEngSkills = matchDropdownOption(engSkills, AGENT_FORM_OPTIONS.englishSkills);
                        const matchedLoc = matchDropdownOption(str3, AGENT_FORM_OPTIONS.preferredLocation);
                        const matchedMode = matchDropdownOption(prefMode, AGENT_FORM_OPTIONS.interviewMode);
                        const matchedHousehold = matchDropdownOption(household, AGENT_FORM_OPTIONS.householdCategory);

                        if (!str1) {
                          isAgentValidationError = true;
                          agentValidationReason = "Name is required";
                        } else if (!str4 || str4.length !== 10) {
                          isAgentValidationError = true;
                          agentValidationReason = "Valid 10-digit Phone Number is required";
                        } else if (!strEmail || !strEmail.match(emailPattern)) {
                          isAgentValidationError = true;
                          agentValidationReason = "Valid Email is required";
                        } else if (!dob) {
                          isAgentValidationError = true;
                          agentValidationReason = "Date of Birth is required";
                        } else if (!household) {
                          isAgentValidationError = true;
                          agentValidationReason = "Does your household fall under any of the following categories? is required";
                        } else if (!matchedHousehold) {
                          isAgentValidationError = true;
                          agentValidationReason = `Invalid dropdown value for Does your household fall under any of the following categories?: '${household}'. Allowed: ${AGENT_FORM_OPTIONS.householdCategory.join(", ")}`;
                        } else if (!selectDept || !selectDesg) {
                          isAgentValidationError = true;
                          agentValidationReason = "Select Department and Select Designation are required";
                        } else if (!matchedQual) {
                          isAgentValidationError = true;
                          agentValidationReason = `Invalid dropdown value for Highest Qualification: '${qual}'. Allowed: ${AGENT_FORM_OPTIONS.qualification.join(", ")}`;
                        } else if (!matchedSource) {
                          isAgentValidationError = true;
                          agentValidationReason = `Invalid dropdown value for How did you come to know about us: '${str2}'`;
                        } else if (!matchedJobType) {
                          isAgentValidationError = true;
                          agentValidationReason = `Invalid dropdown value for What type of job are you looking for?: '${jobType}'. Allowed: ${AGENT_FORM_OPTIONS.jobType.join(", ")}`;
                        } else if (!matchedEngSkills) {
                          isAgentValidationError = true;
                          agentValidationReason = `Invalid dropdown value for English communication skills: '${engSkills}'. Allowed: ${AGENT_FORM_OPTIONS.englishSkills.join(", ")}`;
                        } else if (!matchedLoc) {
                          isAgentValidationError = true;
                          agentValidationReason = `Invalid dropdown value for Preferred Location: '${str3}'. Allowed: ${AGENT_FORM_OPTIONS.preferredLocation.join(", ")}`;
                        } else if (!matchedMode) {
                          isAgentValidationError = true;
                          agentValidationReason = `Invalid dropdown value for Preferred Mode of Interview: '${prefMode}'. Allowed: ${AGENT_FORM_OPTIONS.interviewMode.join(", ")}`;
                        }

                        if (isAgentValidationError) {
                          nullData.push({
                            ...item,
                            Status: "Failed",
                            Reason: agentValidationReason,
                          });
                          continue;
                        } else {
                          const correctObj = {
                            name: str1,
                            email: strEmail,
                            phone: str4,
                            source: matchedSource || str2,
                            location: matchedLoc || str3,
                            current_location: strCurrentLocation,
                            date: str5,
                          };
                          correctData.push(correctObj);
                          continue;
                        }
                      }

                      const isSourceVerified = !sourceFormat.includes(
                        str2.toLowerCase().split(" ").join("")
                      );

                      if (
                        str1 === "" ||
                        str2 === "" ||
                        str4 === "" ||
                        str3 === "" ||
                        str4.length !== 10 ||
                        isFutureDate(str5) ||
                        (strEmail !== "" && !strEmail.match(emailPattern)) ||
                        format.test(str1) ||
                        (str5 !== "" && str5.trim().match(dateFormat) === null) ||
                        format.test(str3) ||
                        !str1.replace(/\s/g, "").length ||
                        !str2.replace(/\s/g, "").length ||
                        !str3.replace(/\s/g, "").length ||
                        !str4.replace(/\s/g, "").length ||
                        !isnum.test(str4) ||
                        isSourceVerified ||
                        !str1.match(alphabets) ||
                        !str3.match(alphabets) ||
                        !str2.match(alphabets) ||
                        (strCurrentLocation !== "" && !/^[a-zA-Z\s]+$/.test(strCurrentLocation))
                      ) {
                        nullData.push({
                          ...item,
                          Status: "Failed",
                          Reason: "Validation error in row (invalid characters or missing fields)",
                        });
                      } else {
                        const correctObj = {
                          name: str1,
                          email: strEmail,
                          phone: str4,
                          source: str2,
                          location: `${str3.charAt(0).toUpperCase()}${str3
                            .slice(1)
                            .toLowerCase()}`,
                          current_location: strCurrentLocation,
                          date: str5,
                        };
                        correctData.push(correctObj);
                      }
                    }

                    setSubmitNullData(nullData);
                    console.log("junk data", nullData);

                    if (nullData?.length > 0) {
                      swal({
                        title: "Please download the Error Report?",
                        text: "Remove errors and submit the file again!",
                        icon: "warning",
                        dangerMode: true,
                      });
                    }
                    // filtered data for getting only correct data from all data
                    const results = correctData.filter(
                      ({ phone: id1 }) =>
                        !data.some(({ phone: id2 }) => id2 === id1)
                    );
                    setSubmitCorrectData(results);
                    console.log("correct data", results);
                  }
                }
              } else {
                setcsvfileError("no data found in csv file");
              }
            } else {
              setcsvfileError("Limit exceeded! (max-2000 candidates allowed)");
            }
          },
        });
      }
    } else {
      setcsvfileError("file size should be less than 5 mb");
    }
  };

  const [responseData, setResponseData] = useState("");

  const handleSubmitCsv = (e) => {
    e.preventDefault();
    setDisableButton(true);
    if (csvdata !== "" && csvfileError === "") {
      setcsvfileError("");

      console.log("=== SUBMITTING BULK UPLOAD TO API ===");
      console.log("File attached in FormData:", file);
      console.log("Sample row passing to backend from CSV:", csvdata[0]);

      //used for page loading
      if (responseData === "") {
        setLoad(false);
      }

      //New instance FormData
      const filedata = new FormData();
      filedata.append("file", file);
      //data.append("fileName", fileName);

      //post data
      console.log("filedata ", file);
      var data = filedata;

      var config = {
        method: "post",
        url:
          "contacts/" +
          id +
          "/UploadBulkUploadCSV_v4/" +
          "userId/" +
          localStorage.getItem("user.id"),
        maxContentLength: "infinity",
        maxBodyLength: "infinity",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
        data: data,
      };

      axios(config)
        .then(function (response) {
          setDisableButton(false);
          if (response !== null) {
            setLoad(true);
            const { NewRecords, AlreaydExist, candidateList } = response.data;
            swal({
              title: `${NewRecords} New Records Inserted`,
              text: `${AlreaydExist} Already registered`,
              icon: "success",
              dangerMode: true,
              buttons: {
                cancel: {
                  text: "Cancel",
                  value: false,
                  visible: true,
                  closeModal: true,
                  className: 'btn btn-danger'
                },
                download: {
                  text: "Download",
                  value: true,
                  visible: true,
                  className: "btn btn-primary",
                }
              }
            }).then((willDelete) => {
              if (willDelete) {
                exportFromJSON({
                  data: candidateList,
                  exportType: "csv",
                  fileName: isAgentForm ? "Agent_Application_Upload_Report" : "Bulk_Upload_Report"
                });
              }
              window.location.reload();
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          setResponseData(error);
          setLoad(true);
          swal("Oops...", "Something went wrong!", "Network Error");
        });
    } else {
      setsubmitcsvdata("");
    }
  };

  return (
    <div>
    {!isConsultant() && <Dashboard title="Form Contacts">
      {/* <h1 className="mt-5">Send to candidates</h1>
        <ContactCreator form={id} loadContacts={loadContacts} /> */}

      {load === false ? (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      ) : (
        <div></div>
      )}

      {/* bulk upload section*/}
      <div className="container-fluid px-0 my-5">
        <div className="row">
          <div className="col-md-3">
            <div>
              <select
                name="bulk_upload"
                id="bulk_upload"
                className="form-control "
                value={bulkUpload}
                onChange={handleBulkUpload}
                // ref={interviewStatusRef}
              >
                <option selected hidden disabled value="">
                  upload file...
                </option>
                {/* <option value="Excel">Excel</option> */}
                <option value="CSV">CSV</option>
              </select>
            </div>
            {/* <div>
                {bulkUpload === "Excel" ? (
                  <div>
                    <div className="form">
                      <form
                        className="form-group w-100"
                        autoComplete="off"
                        onSubmit={handleSubmit}
                      >
                        <div className="py-3 bg-white">
                          <label>
                            <h5>Upload Excel file</h5>
                          </label>
                          <br></br>
                          <div className="d-flex align-items-center gap-1">
                            <div className="w-50">
                              <input
                                type="file"
                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                className="form-control"
                                onChange={handleFile}
                                required
                              ></input>
                              {excelFileError && (
                                <div
                                  className="text-danger"
                                  style={{ marginTop: 5 + "px" }}
                                >
                                  {excelFileError}
                                </div>
                              )}
                            </div>
                            <div className="w-50">
                              <button
                                type="submit"
                                className="btn btn btn-primary btn-block"
                                style={{ marginTop: 5 + "px" }}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}

                {bulkUpload === "CSV" ? (
                  <div className="py-3 bg-white">
                    <label className="py-2">
                      <h5>Upload CSV file</h5>
                    </label>
                    <br></br>
                    <form className="form-group" autoComplete="off">
                      <div className="App align-items-center d-flex gap-1 ">
                        <div className="w-50">
                          <input
                            type="file"
                            accept=".csv"
                            onChange={handlecsvdata}
                            required
                          />
                          {csvfileError && (
                            <div
                              className="text-danger"
                              style={{ marginTop: 5 + "px" }}
                            >
                              {csvfileError}
                            </div>
                          )}
                        </div>
                        <div className="w-50">
                          <button
                            className="btn btn btn-primary btn-block"
                            type="submit"
                            onClick={handleSubmitCsv}
                          >
                            submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                ) : (
                  <div></div>
                )}
              </div> */}
          </div>
          <div className="col-lg-4  d-flex justify-content-center">
            <div>
              <button
                className="btn btn-primary px-5"
                onClick={handleClickSample}
              >
                Download sample
              </button>
            </div>
            <div>
              {submitNullData?.length > 0 ? (
                <button
                  className="btn btn-primary px-5"
                  onClick={downloadFinalData}
                >
                  Download Report
                </button>
              ) : (
                <div></div>
              )}
            </div>
          </div>
        </div>

        {bulkUpload === "Excel" || bulkUpload === "CSV" ? (
          <div className="row mt-3">
            <div className="col-md-6 ">
              <div className="card w-100">
                <div className="card-body">
                  {bulkUpload === "CSV" ? (
                    <div className="py-3 bg-white">
                      <label className="py-2">
                        <h5>Upload CSV file</h5>
                      </label>
                      <br></br>
                      <form className="form-group" autoComplete="off">
                        <div className="App align-items-center d-flex gap-1 ">
                          <div className="w-50">
                            <input
                              type="file"
                              accept=".csv"
                              onChange={handlecsvdata}
                              required
                            />
                            {csvfileError && (
                              <div
                                className="text-danger"
                                style={{ marginTop: 5 + "px" }}
                              >
                                {csvfileError}
                              </div>
                            )}
                          </div>
                          {submitNullData?.length === 0 && csvfileError === "" && (
                            <div className="w-50">
                              <button
                                disabled={disableButton}
                                className="btn btn btn-primary btn-block"
                                type="submit"
                                onClick={handleSubmitCsv}
                              >
                                submit
                              </button>
                            </div>
                          )}
                        </div>
                      </form>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}
       {/* //   <ContactCreator form={id} /> */}
      </div>
      {/* // {load===false &&  <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />} */}
    </Dashboard>}
    </div>
  );
}

export default FormContacts;
